/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const TextInitial = [
  ["path", { d: "M15 5h6" }],
  ["path", { d: "M15 12h6" }],
  ["path", { d: "M3 19h18" }],
  ["path", { d: "m3 12 3.553-7.724a.5.5 0 0 1 .894 0L11 12" }],
  ["path", { d: "M3.92 10h6.16" }]
];

export { TextInitial as default };
//# sourceMappingURL=text-initial.js.map
